import { render, staticRenderFns } from "./LicensePage.vue?vue&type=template&id=19143e76"
import script from "./LicensePage.vue?vue&type=script&lang=js"
export * from "./LicensePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports